import React from 'react';
interface LotusMarkProps {
  className?: string;
}
/**
 * Champagne-gold line-art recreation of the Libelle lotus mark.
 * Built as crisp SVG so it stays sharp at oversized scales and lets us
 * control the metallic gradient, opacity and animation precisely.
 */
export function LotusMark({
  className = ''
}: LotusMarkProps) {
  return <svg viewBox="0 0 400 460" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden="true" role="presentation" data-id="element-269">
      <defs data-id="element-270">
        <linearGradient id="lotus-champagne" x1="80" y1="40" x2="320" y2="440" gradientUnits="userSpaceOnUse" data-id="element-271">
          <stop offset="0%" stopColor="#EBD9B4" data-id="element-272" />
          <stop offset="38%" stopColor="#C9A961" data-id="element-273" />
          <stop offset="62%" stopColor="#DEC68C" data-id="element-274" />
          <stop offset="100%" stopColor="#B08D4A" data-id="element-275" />
        </linearGradient>
      </defs>

      <g stroke="url(#lotus-champagne)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-276">
        {/* Radiating rays */}
        <line x1="200" y1="20" x2="200" y2="58" data-id="element-277" />
        <line x1="158" y1="30" x2="170" y2="64" data-id="element-278" />
        <line x1="242" y1="30" x2="230" y2="64" data-id="element-279" />
        <line x1="124" y1="50" x2="146" y2="78" data-id="element-280" />
        <line x1="276" y1="50" x2="254" y2="78" data-id="element-281" />

        {/* Top diamond */}
        <path d="M200 92 L218 116 L200 140 L182 116 Z" data-id="element-282" />

        {/* Outer left petal */}
        <path d="M200 300 C 120 280, 70 230, 60 188 C 110 188, 168 226, 200 300 Z" data-id="element-283" />
        {/* Outer right petal */}
        <path d="M200 300 C 280 280, 330 230, 340 188 C 290 188, 232 226, 200 300 Z" data-id="element-284" />

        {/* Inner left petal */}
        <path d="M200 300 C 156 278, 132 240, 132 206 C 168 214, 192 252, 200 300 Z" data-id="element-285" />
        {/* Inner right petal */}
        <path d="M200 300 C 244 278, 268 240, 268 206 C 232 214, 208 252, 200 300 Z" data-id="element-286" />

        {/* Center descending petal */}
        <path d="M200 300 C 186 348, 186 400, 200 436 C 214 400, 214 348, 200 300 Z" data-id="element-287" />
      </g>
    </svg>;
}